export default "__VITE_ASSET__VJDSFDAd__"